import { Info } from "@/types/user";
import {
  getCookie, setCookie
} from 'cookies-next/client';
import { decrypt, encrypt } from "./token";
const domain = globalThis.constructor.name === "Window" 
  && location.hostname === "localhost" ? "http://localhost:8080" : "";

export default async function getUser() {
  try {
    const cookie = getCookie("cidadao_token") as string | undefined;
    if (cookie) {
      const data = await decrypt(cookie);
      return data
    }
    const response = await fetch(`${domain}/api/auth/info`);
    const json = response.json() as Promise<Info>;
    const data = await json
    if ((data as Info)?.sub) {
      setCookie("cidadao_token", await encrypt(data));
    }
    return data
  } catch(error) {
    console.error("Error fetching user info:", error);
    return null
  }
}
